var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c("b-col", [
            _c("h3", { staticClass: "grey-color main_text font-weight-bold" }, [
              _vm._v("История рейтинга"),
            ]),
          ]),
          _c(
            "b-col",
            { attrs: { md: "auto" } },
            [
              _vm.$store.state.organization.rating
                ? _c(
                    "b-badge",
                    {
                      staticClass: "mt-1 fs-18",
                      attrs: { variant: "custom-green" },
                    },
                    [
                      _c("b-icon-star-fill"),
                      _c("span", { staticClass: "ml-2" }, [
                        _vm._v(_vm._s(_vm.$store.state.organization.rating)),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("b-table", {
        staticClass: "table-atmo",
        attrs: {
          busy: _vm.isLoading,
          fields: _vm.fields,
          items: _vm.ratings,
          "empty-text": "Нет данных",
          "show-empty": "",
        },
        scopedSlots: _vm._u([
          {
            key: "table-busy",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "text-center my-2" },
                  [
                    _c("b-spinner", { staticClass: "align-middle mr-1" }),
                    _c("strong", [_vm._v("Загрузка данных...")]),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "cell(rate_date)",
            fn: function (row) {
              return [
                _vm._v(" " + _vm._s(_vm.$formatDate(row.item.rate_date)) + " "),
              ]
            },
          },
          {
            key: "cell(purchasable_id)",
            fn: function (row) {
              return [
                _c(
                  "router-link",
                  {
                    staticClass: "atmo-button-link fw-400",
                    attrs: {
                      to: {
                        name: "purchases.grouped.item.view",
                        params: { group: "fl44", id: row.item.purchasable_id },
                      },
                      target: "_blank",
                    },
                  },
                  [_vm._v(" " + _vm._s(row.item.purchase_reg_number) + " ")]
                ),
              ]
            },
          },
          {
            key: "cell(customer_id)",
            fn: function (row) {
              return [
                row.item.customer_id
                  ? _c(
                      "router-link",
                      {
                        staticClass: "atmo-button-link",
                        attrs: {
                          to: {
                            name: "OrganizationShow",
                            params: { id: row.item.customer_id },
                          },
                          target: "_blank",
                        },
                      },
                      [_vm._v(" " + _vm._s(row.item.customer_name) + " ")]
                    )
                  : _c("span", [
                      _vm._v(
                        " Запись о рейтинге создана автоматически при заключении договора "
                      ),
                    ]),
              ]
            },
          },
          {
            key: "cell(actions)",
            fn: function (data) {
              return [
                data.item.customer_id || data.item.comment
                  ? _c("action-button-small", {
                      directives: [
                        {
                          name: "b-popover",
                          rawName: "v-b-popover.hover.top",
                          value:
                            (data.detailsShowing ? "Скрыть" : "Показать") +
                            " подробности",
                          expression:
                            "(data.detailsShowing ? 'Скрыть' : 'Показать') + ' подробности'",
                          modifiers: { hover: true, top: true },
                        },
                      ],
                      attrs: {
                        icon: data.detailsShowing ? "eye-slash" : "eye",
                      },
                      on: { click: data.toggleDetails },
                    })
                  : _vm._e(),
              ]
            },
          },
          {
            key: "row-details",
            fn: function (data) {
              return [
                data.item.user_name
                  ? _c("p", [
                      _c("b", [_vm._v("Пользователь заказчика:")]),
                      _vm._v(" " + _vm._s(data.item.user_name)),
                    ])
                  : _vm._e(),
                data.item.comment
                  ? _c("p", [
                      _c("b", [_vm._v("Комментарий:")]),
                      _vm._v(" " + _vm._s(data.item.comment)),
                    ])
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }